import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import ErrorPage from 'app/components/ErrorPage';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import { hasAdminPermissions } from 'app/helpers/browse/admin';
import { LOCAL_STORAGE_KEY, MOCK_BROWSE_HOME_PAGE_INDEX } from 'app/constants/browse/home';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import AdminBrowseHomePage from './AdminBrowseHomePage';

// eslint-disable-next-line no-unused-vars
const AdminBrowseHomePageContainer = ({ basePageRoute }) => {
  const currentUser = useSelector(selectCurrentUser);

  const [state, setState] = useState({
    browseHomePages: [],
    isLoading: true
  });

  useEffect(() => {
    let storedBrowseHomePageIndex = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));

    if (!storedBrowseHomePageIndex) {
      storedBrowseHomePageIndex = MOCK_BROWSE_HOME_PAGE_INDEX;

      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storedBrowseHomePageIndex));
    }

    const browseHomePages = Object.keys(storedBrowseHomePageIndex).map(
      browseHomePageId => storedBrowseHomePageIndex[browseHomePageId]
    );

    setState(() => {
      return {
        browseHomePages,
        isLoading: false
      };
    });
  }, [setState]);

  const canViewPage = hasAdminPermissions(currentUser);
  if (!canViewPage) {
    return <ErrorPage httpStatusCode={HTTP_STATUS_CODE.FORBIDDEN} />;
  }

  const { browseHomePages, isLoading } = state;
  if (isLoading) {
    return <p>Loading...</p>;
  }

  return <AdminBrowseHomePage browseHomePages={browseHomePages} />;
};

AdminBrowseHomePageContainer.propTypes = {
  basePageRoute: PropTypes.string.isRequired
};

export default AdminBrowseHomePageContainer;
